import stickybits from 'stickybits'

let instance
export default {
  inserted (el) {
    if (!el) {
      return
    }

    instance = stickybits(el)
  },

  unbind () {
    if (instance && typeof instance.cleanup === 'function') {
      instance.cleanup()
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/sticky.js